import * as user from "./user";
import * as account from "./account";

export default {
    user,
    account,
};
